import { render, staticRenderFns } from "./mind-map.vue?vue&type=template&id=72cd48c8&scoped=true&"
import script from "./mind-map.vue?vue&type=script&lang=js&"
export * from "./mind-map.vue?vue&type=script&lang=js&"
import style0 from "./mind-map.vue?vue&type=style&index=0&id=72cd48c8&scoped=true&lang=css&"
import style1 from "./mind-map.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd48c8",
  null
  
)

export default component.exports